import React from "react";

export const TvHero = () => {
  return (
    <div className="tv-hero">
      <div className="tv-hero-bg"></div>
      {/* hero image rendering on _tvHero.scss */}
      <div className="text-ct">
        <h2>
          PSG TV <span className="premiun">PREMIUM</span>
        </h2>
        <div className="promo-ct">
          <p>
            <span>PSG TV Premium</span> es la mejor oferta en línea para{" "}
            <span>
              revivir todos
              <br />
              los partidos
            </span>{" "}
            de la temporada del Paris Saint-Germain <span>íntegros.</span>{" "}
          </p>
          <ul>
            <li>Partidos integros</li>
            <li>Resumenes de 10 minutos</li>
            <li>Contenidos exclusivos</li>
          </ul>
        </div>

        <button>LEER MAS</button>
      </div>
    </div>
  );
};
